import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { useI18n } from '@udemy-v2/i18n';
import styles from './premium-course-notice.module.scss';
export const PremiumCourseNotice = () => {
  const $ = _c(5);
  const {
    gettext
  } = useI18n();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Icon glyph="verified" size="xsmall" label={false} color="info" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== gettext) {
    t1 = gettext("This Premium course is included in plans");
    $[1] = gettext;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className={styles.container}>{t0}<span className="ud-text-sm">{t1}</span></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};